
<PoppinsCareTypeCardGroup
  :careTypes="sitterCareTypes"
  :headingText="headingText"
  :subheadingText="subheadingText"
  @select="handleSelect"
/>
